module.exports = __webpack_public_path__ + "img/20191115130754360截图20190822131714345.bb4a3a74.jpg";